// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LocationHelper {
  public static getPathname() {
    if (import.meta.client) {
      return window.location.pathname;
    }
    return useRequestURL().pathname;
  }
}
